import { useTranslation } from 'react-i18next';

import Link from '@/components/LangLink/LangLink';
import MainMenu from '@/components/MainMenu/MainMenu';
import MymDropdown from '@/components/MymDropdown/MymDropdown';
import { useNavigationStore } from '@/store/useNavigationStore';
import { splitTerm } from '@/utils/splitTerm';

function Header({ page }) {
    const { t } = useTranslation();
    const expoTitle = useNavigationStore((s) => s.expoTitle);
    const { primary, secondary } = splitTerm(expoTitle, '|');

    return (
        <header className="main-header is-relative">
            <title>{expoTitle}</title>
            <a href="#main" className="skip-link">
                {t('saltar contenido principal')}
            </a>
            <a href="#main-nav" className="skip-link">
                {t('saltar menu principal')}
            </a>

            <div className="wrapper is-relative is-flex is-align-items-center gap-5 h-100">
                {expoTitle && page !== 'home' && (
                    <p className="main-header--link-home is-size-6 is-uppercase has-text-weight-bold">
                        <Link to="/" className="has-text-primary link-dn is-family-secondary">
                            {primary}.
                        </Link>{' '}
                        <span>{secondary}</span>
                    </p>
                )}

                <div className="ml-auto is-flex is-align-items-center h-100">
                    <MainMenu />
                    <MymDropdown />
                </div>
            </div>
        </header>
    );
}

export default Header;
